module.exports = __webpack_public_path__ + "static/media/Magnifier_Pressed.54ebd883.svg";